var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FlexGrid } from '@telus-uds/components-web';
import styled from 'styled-components';
export var PageSection = function (_a) {
    var children = _a.children, id = _a.id, _b = _a.showSection, showSection = _b === void 0 ? true : _b, _c = _a.flexGridProps, flexGridProps = _c === void 0 ? {
        limitWidth: true,
        gutter: true
    } : _c, _d = _a.tag, tag = _d === void 0 ? 'section' : _d;
    if (!showSection)
        return false;
    return (_jsx(StyledPageSectionWrapper, { as: tag, "data-testid": id !== null && id !== void 0 ? id : 'page-section', id: id, children: _jsx(FlexGrid, { gutter: flexGridProps === null || flexGridProps === void 0 ? void 0 : flexGridProps.gutter, limitWidth: flexGridProps === null || flexGridProps === void 0 ? void 0 : flexGridProps.limitWidth, children: _jsx(FlexGrid.Row, { children: _jsx(FlexGrid.Col, { children: children }) }) }) }));
};
export default PageSection;
var StyledPageSectionWrapper = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
